import { Col, Container, Row } from "react-bootstrap";

import { Fragment, useState } from "react";

import Banner from "../components/Banner/Banner";
import useWindowScrollToTop from "../hooks/useWindowScrollToTop";

import Shipping from "./Shipping";


const ShippingPage = () => {

  useWindowScrollToTop();

  return (
    <Fragment>
      <Banner title="Shipping Policy" />
   
        <Container className="filter-bar-contianer">
          
        </Container>
        <Container>
         <Shipping/>
        
        </Container>
 
    </Fragment>
  );
};

export default ShippingPage;
